import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import { AxiosInstance } from 'axios'
import * as firebase from 'firebase/app';
import "firebase/firebase-firestore";
import "firebase/firebase-storage";
import "firebase/auth";
import { estado } from './fuentes.js'


Vue.config.productionTip = false


new Vue({
  router,
	vuetify,
	data: () => ({
		axios: null as AxiosInstance | null,
		firebase: null as firebase.app.App | null,
		firestore: null as firebase.firestore.Firestore | null,
		storageRef: null as firebase.storage.Reference | null,
		autenticación: {
			cargaInicial: false,
			autenticando: false,
			cargandoUsuario: false,
			usuario: null as firebase.User | null
		},
		usuario: {},
		cuenta: {
			identificador: ''
		},
		mensaje: {
			activo: false,
			color: '',
			descripción: '',
		},
		sitios: {
			cargando: false,
			listado: []
		},
		dominios: {
			cargando: false,
			listado: []
		},
		escuchas: {
			dominios: null as (() => void) | null,
			cuentasSitios: null as (() => void) | null
		}
	}),
	mounted: function() {

		this.firebase = firebase.initializeApp({
			apiKey: "AIzaSyD6QL2Giq9ApR__x6KboHzDtraE7k4h-o0",
			authDomain: "sitios-c19fc.firebaseapp.com",
			databaseURL: "https://sitios-c19fc.firebaseio.com",
			projectId: "sitios-c19fc",
			storageBucket: "sitios-c19fc.appspot.com",
			messagingSenderId: "203722643069",
			appId: "1:203722643069:web:f19fafbb2f30785e018314"
		})

		this.firestore = this.firebase.firestore();

		//
		// Empieza autenticación
		this.firebase.auth().onAuthStateChanged( user => {
			this.autenticación.autenticando = false
			if (user) {
				this.autenticación.usuario = user
				user.getIdToken().then(tkn => {
					if (!this.firestore) {
						return Promise.reject()
					}

					this.autenticación.cargandoUsuario = true
					this.firestore.collection('usuarios').doc(user.uid).get().then( doc => {
						let datos = doc.data()
						if (doc.exists && datos && datos.cuentas && datos.cuentas.length && datos.cuentas[0]) {
							this.usuario = Object.assign({identificador: user.uid, correo: user.email, token: tkn}, datos)
							this.cuenta = datos.cuentas[0] // pendiente manejar múltiples cuentas...
							estado.inicializarTemporal(this.firebase, this.firestore, this.cuenta)

							if (!this.axios || !this.firebase || !this.firestore) {
								return Promise.reject()
							}

							this.axios.defaults.headers.common['Authorization'] = `Bearer ${tkn}`
							this.axios.defaults.headers.common['X-Cuenta'] = this.cuenta.identificador

							// Storage:
							this.storageRef = this.firebase.storage().ref().child('cuentas').child(this.cuenta.identificador);

							// Obtener listado de dominios
							this.dominios.cargando = true
							this.escuchas.dominios = this.firestore.collection('dominios').where('cuenta', '==', this.cuenta.identificador).onSnapshot( snapshot => {
								this.manejarCambiosFirebase(this.dominios.listado, snapshot)
								this.dominios.cargando = false
							})

							// Obtener listado de sitios
							this.sitios.cargando = true
							this.escuchas.cuentasSitios = this.firestore.collection('cuentas').doc(this.cuenta.identificador).collection('sitios').onSnapshot( snapshot => {
								this.manejarCambiosFirebase(this.sitios.listado, snapshot)
								this.sitios.cargando = false
							})

						} else {
							console.error('[6423] Ocurrió un error: No se pudo obtener el usuario.')
							this.error('[6423] Ocurrió un error')
						}
						this.autenticación.cargandoUsuario = false
						this.autenticación.cargaInicial = true
					}).catch( err => {
						console.error('[6424]', err)
						this.error('[6424] Ocurrió un error')
						this.autenticación.cargandoUsuario = false
						this.autenticación.cargaInicial = true
					})
				}).catch(err => {
					console.error('[7539] Ocurrió un error.', err)
				})
			} else {
				if (this.escuchas.dominios) {
					this.escuchas.dominios()
				}
				if (this.escuchas.cuentasSitios) {
					this.escuchas.cuentasSitios()
				}
				if (estado.desconectar) { // este reemplazaría los dos anteriores
					estado.desconectar()
				}
				this.usuario = {}
				this.cuenta.identificador = ''
				estado.cuenta.identificador = '' // este reeemplazará el anterior
				this.dominios.listado = []
				this.sitios.listado = []
				this.autenticación.cargaInicial = true
				this.autenticación.usuario = null
			}
		});
		// Termina autenticación
		//

		this.axios = axios.create({
			baseURL: 'https://sitios.neorred.com:9090',
			timeout: 20000,
			headers: { 'content-type': 'application/x-www-form-urlencoded' }
		})

		this.axios.interceptors.request.use(async (config) => {
			let data: any = {};
			for (let l in config.data) {
				if (typeof config.data[l] === 'string') {
					data[l] = config.data[l]
				} else {
					data[l] = JSON.stringify(config.data[l])
				}
			}
			config.data = new URLSearchParams(data)

			if (this.autenticación.usuario) {
				let tkn = await this.autenticación.usuario.getIdToken()
				config.headers.Authorization = `Bearer ${tkn}`
			}

			return config
		});

	},

	methods: {
		aleatorio: function() {
			return ((Math.random()).toString()).replace('0.', '')
		},
		error: function(msj: string): void {
			this.mensaje.activo = false
			this.mensaje.descripción = msj
			this.mensaje.color = 'error'
			this.mensaje.activo = true
		},
		correcto: function(msj: string) {
			this.mensaje.activo = false
			this.mensaje.descripción = msj
			this.mensaje.color = 'green'
			this.mensaje.activo = true
		},
		manejarCambiosFirebase: function(listado: any, snapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>) {
			snapshot.docChanges().forEach( change => {
				if (change.type === "added") {
					listado.push({ identificador: change.doc.id, datos: change.doc.data() })
				}
				if (change.type === "modified") {
					for (let i in listado) {
						if (listado[i].identificador === change.doc.id) {
							this.$set(listado, i, { identificador: change.doc.id, datos: change.doc.data() })
							break
						}
					}
				}
				if (change.type === "removed") {
					for (let i in listado) {
						if (listado[i].identificador === change.doc.id) {
							this.$delete(listado, i)
							break
						}
					}
				}
			})
		},
		obtenerSitio: function(identificador: string) {
			return this.obtenerDesdeListadoPorIdentificador('sitios', identificador)
		},
		obtenerDominio: function(dominio: string) {
			return this.obtenerDesdeListadoPorIdentificador('dominios', dominio)
		},
		obtenerDesdeListadoPorIdentificador: function(objeto: string, identificador: string) {
			if (!identificador) {
				return null
			}

			let obj: any = objeto === 'sitios' ? this.sitios : objeto === 'dominios' ? this.dominios : null
			if (!obj) {
				return null
			}

			for (let o of obj.listado) {
				if (o.identificador === identificador) {
					return o
				}
			}

			if (!obj.cargando) {
				// No debería llegar acá
				this.error('[4390] Ocurrió un error.')
			}

			return null
		}
	},

  render: h => h(App)
}).$mount('#app')
